import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import LecPaperHomeSection from "../components/lec_paper_generator/LecPaperHomeSection";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import Preloader from "../components/preloader/Preloader";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
  } from "react-device-detect";
  
const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        exams{
            id
            exam
            exam_subjects{
                subject_id
            }
            avg_question_time
        }
        globalBranches{
            id
            branch_name
        }
        classes{
            id
            class
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
        }
        subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                    # practice_percentage
                }
                class
            }
            state_chapters{
                id
                chapter
                exam_id
                state_topics{
                    id
                    topic
                }
                class
            }
        }
        questionTypes{
            id
            questiontype
        }
        questionTheory{
            id
            question_theory
        }
        complexity{
            id
            complexity
            
        }
    }
}

`;

const FETCH_PAPERGENERATETYPE = gql` 
query($id: Int) {
    getExamModelTypes(id: $id){
        id
        exam_model
        course_id
        no_of_questions
        time_duration
    }
}

`;


const FETCH_SAVED_PAPERS = gql`
  query($institution_id: Int!) {
    getSavedLecPapers(institution_id: $institution_id) {
        id
        name
        exam_type
        no_of_sets
        start_time
        end_time
        time_duration
        is_completed
        class
        section
        branch
        type
        class_id
        exam_model_id
        is_partexam
        mains_2021
        timestamp
        estatus
        sub_exam_type
        total_question_count
        time_duration
        exam_model_type_id
        
    }
  }
`;


const FETCH_LEC_SCHEDULED_PAPERS = gql`
  query($institution_id: Int!) {
    getLecScheduledPaper(institution_id: $institution_id) {
        schedulequiz{
            id
            exam_name
            exam_type
            section
            branch
            type
            class_id
            is_completed
            time_duration
            exam_model_type_id
            start_time
            end_time
            publish
            estatus
            timestamp
            institution_id
            is_draft
            total_students
            
            
        }
       
    }
  }
`;

const FETCH_CRASHCOURSE_EXAMS= gql`
query($institution_id: Int!){
    getEamcetCourseExams(institute_id: $institution_id){
        id
        exam_name
        exam_model_type_id
        start_time
        end_time  
      }
}
`

class LecPaperGenerator extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: Cookies.get("toggle")
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

       

        const savedPapers = this.props.getSavedLecPapers;
        const loading4 = savedPapers.loading;
        const error4 = savedPapers.error;


        const getExamModelTypes = this.props.getExamModelTypes;
        const loading6 = getExamModelTypes.loading;
        const error6 = getExamModelTypes.error;

        const getLecScheduledPaper = this.props.getLecScheduledPaper;
        const loading5 = getLecScheduledPaper.loading;
        const error5 = getLecScheduledPaper.error;

        const getEamcetCourseExams=this.props.getEamcetCourseExams
        const loading7=getEamcetCourseExams.loading
        const error7=getEamcetCourseExams.error
        

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        
       
       if (error4 !== undefined) {
            alert("Server Error. " + error4.message);
            return null;
        }
        
        if (error6 !== undefined) {
            alert("Server Error. " + error6.message);
            return null;
        }
        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }

        if (error7 !== undefined) {
            alert("Server Error. " + error7.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                    <SideNavbar />
                </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                        <div className="content-wrapper mb-2" style={{ minHeight: "50vh" }}>
                            {
                            loading1 || loading4 || loading5 ||loading7 || loading6 ?
                                    (
                                        <Container><Row className="my-3">
                                            <Col>
                                                <div class="spinner-border text-primary text-center loading-img-center"></div>
                                            </Col>
                                        </Row></Container>
                                    )
                                    :
                                    (
                                        <LecPaperHomeSection
                                            globals={globals.globals}
                                            savedPapers={savedPapers.getSavedLecPapers}
                                            getExamModelTypes={getExamModelTypes.getExamModelTypes}
                                            getLecScheduledPaper={getLecScheduledPaper.getLecScheduledPaper}
                                            getEamcetCourseExams={getEamcetCourseExams.getEamcetCourseExams}
                                            />
                                    )
                            }
                                
                        </div>
                    <Footer />
                </div>
            </div>
        );

    }
}




export default withRouter(
    compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "globals"
            }),
            graphql(FETCH_SAVED_PAPERS, {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    },
                    fetchPolicy:'network-only',
                }),
                name: "getSavedLecPapers"
            }),
            graphql(FETCH_PAPERGENERATETYPE, {
                options: props => ({
                    variables: {
                        id: 0
                    },
                    fetchPolicy:'network-only',
                }),
                name: "getExamModelTypes"
            }),
            graphql(FETCH_LEC_SCHEDULED_PAPERS, {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    },
                    fetchPolicy:'network-only',
                }),
                name: "getLecScheduledPaper"
            }),
            graphql(FETCH_CRASHCOURSE_EXAMS, {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    },
                    fetchPolicy:'network-only',
                }),
                name: "getEamcetCourseExams"
            }),
    )
        (LecPaperGenerator));
